import { Component, OnDestroy, OnInit } from "@angular/core";
import { FabButtonService } from "src/app/services/fab-button.service";

@Component({
  selector: "app-default",
  templateUrl: "./default.component.html",
})
export class DefaultComponent  implements OnInit, OnDestroy {

  constructor(
    private fab: FabButtonService
  ) {}

  ngOnInit(): void {
    this.fab.setDefaultButtons();
  }
  ngOnDestroy(): void {
    this.fab.clearButtons();
  }
}
